// extracted by mini-css-extract-plugin
export default {"author":"Author_author__CYTMP","trigger":"Author_trigger__XDpmO"};